import { render, staticRenderFns } from "./piechart3.vue?vue&type=template&id=2cea720a&"
import script from "./piechart3.vue?vue&type=script&lang=js&"
export * from "./piechart3.vue?vue&type=script&lang=js&"
import style0 from "./piechart3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports